import { SignUpForm } from './SignUpForm'

interface SignUpStepProps {
  onComplete: (customerInfoId: string, email: string) => void
}

export function SignUpStep({ onComplete }: SignUpStepProps) {
  return <SignUpForm onSuccess={onComplete} />
}
